import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {
  SRP_FETCH_RECOMMENDED_PRODUCTS_FAILURE,
  SRP_FETCH_RECOMMENDED_PRODUCTS_START,
  SRP_FETCH_RECOMMENDED_PRODUCTS_SUCCESS,
} from "../actions";
import { type SrpProductData } from "~/utils/models";

export interface ProductsOnSaleState {
  productsOnSale: string[];
  productsOnSaleInFlight: boolean;
}

export const productsOnSaleInitialState: ProductsOnSaleState = {
  productsOnSale: [],
  productsOnSaleInFlight: false,
};

export const productsOnSaleSlice = createSlice({
  name: "productsOnSale",
  initialState: productsOnSaleInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SRP_FETCH_RECOMMENDED_PRODUCTS_START, (state) => {
        state.productsOnSaleInFlight = true;
        state.productsOnSale = [];
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .addCase(SRP_FETCH_RECOMMENDED_PRODUCTS_SUCCESS, (state, action: PayloadAction<SrpProductData[]> | any) => {
        const products = action.payload;
        state.productsOnSale = products.map((product: SrpProductData) => product.code);
        state.productsOnSaleInFlight = false;
      })
      .addCase(SRP_FETCH_RECOMMENDED_PRODUCTS_FAILURE, (state) => {
        state.productsOnSaleInFlight = false;
      });
  },
});

export const productsOnSaleReducer = productsOnSaleSlice.reducer;
